import image from "./language.svg";
import iconEN from "./english.svg";
import iconDE from "./german.svg";
import iconFR from "./france.svg";
import { FormattedMessage, useIntl } from "react-intl";
import {
  BottomButton,
  BottomButtonContainer,
} from "../../../elements/wrapper/bottomButton.wrapper.jsx";
import StandardRadioButton from "../../../elements/buttons/standardRadioButton.jsx";
import { getQueryParams } from "../../../../app/RouteWithSubRoutes";
import IntroImage from "../../introImage.component.jsx";
import StandardHeadline from "../../../elements/text/standardHeadline.text.jsx";
import StandardInstruction from "../../../elements/text/standardInstruction.component.jsx";
import { pageNames } from "../../../../reduxStore/reducers/main";
import { useEffect } from "react";

export default function Language(props) {
  const intl = useIntl();

  const handleClick = () => {
    props.history.push(
      `/${pageNames.intro}/${pageNames.selectUserGroup}/${getQueryParams()}`
    );
  };

  const languages = [
    {
      name: intl.formatMessage({ id: "welcome.languageSelectionGerman" }),
      key: "de",
      flag: <img src={iconDE} />,
    },
    {
      name: intl.formatMessage({ id: "welcome.languageSelectionFrench" }),
      key: "fr",
      flag: <img src={iconFR} />,
    },
    {
      name: intl.formatMessage({ id: "welcome.languageSelectionEnglish" }),
      key: "en",
      flag: <img src={iconEN} />,
    },
    /* {
      name: intl.formatMessage({ id: "welcome.languageSelectionChinese" }),
      key: "cn",
      flag: <img src={iconCN} />,
    }, */
  ];
  useEffect(() => {
    // throw to login
    if (props.piKeyState) return;

    props.history.push(`/${pageNames.intro}/${pageNames.login}`);
  }, [props.piKeyState]);

  return (
    <>
      <BottomButtonContainer
        buttons={[
          new BottomButton(
            handleClick,
            <FormattedMessage id="welcome.next" />,
            { className: "normalButton--primary" }
          ),
          ,
        ]}
      >
        <IntroImage imageName={"language.svg"} fallbackImage={image} />
        <div className={"pl-3 pr-3"}>
          <StandardHeadline className={"mb-2 mt-3"} type={"h2"}>
            <FormattedMessage id="welcome.languageSelectionTitle" />
          </StandardHeadline>
          <StandardInstruction className={"mb-4"} type={"p"}>
            <FormattedMessage id="welcome.languageSelectionText" />
          </StandardInstruction>

          <div className="d-flex flex-column pl-3 pr-3">
            {languages.map((l) => (
              <div
                className="general-margin-bottom d-flex justify-content-between"
                key={l.key}
                onClick={() => props.setLanguage(l.key)}
              >
                <div>
                  {l.flag}
                  <span className="d-inline-block general-padding-large-horizontally">
                    {l.name}
                  </span>
                </div>
                <StandardRadioButton selected={l.key === props.language} />
              </div>
            ))}
          </div>
        </div>
      </BottomButtonContainer>
    </>
  );
}
